import { render } from "./ViewCase.vue?vue&type=template&id=162fe0fb&scoped=true"
import script from "./ViewCase.vue?vue&type=script&lang=js"
export * from "./ViewCase.vue?vue&type=script&lang=js"

import "./ViewCase.vue?vue&type=style&index=0&id=162fe0fb&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162fe0fb"],['__file',"src/views/cases/ViewCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "162fe0fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('162fe0fb', __exports__)) {
    console.log('reload')
    api.reload('162fe0fb', __exports__)
  }
  
  module.hot.accept("./ViewCase.vue?vue&type=template&id=162fe0fb&scoped=true", () => {
    console.log('re-render')
    api.rerender('162fe0fb', render)
  })

}


export default __exports__